import React, { useEffect } from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

import * as IMI from '../../lib/ManiaFrameWork/js/mania';

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Forms',
  },
  {
    path: 'SelectBox',
    breadcrumbName: 'SelectBox',
  },
];

const SelectBox_Component = () => {
  useEffect(() => document.querySelectorAll('[data-rule="selectbox"]').forEach((el) => new IMI.Selectbox(el)), []);
  return (
    <>
      <PageHeader title="SelectBox" breadcrumb={{ routes }} subTitle="SelectBox" style={{ padding: 10 }} />

      <div className="MF_area">
        <div className="selectbox">
          <div className="btn btn_selectbox" data-rule="selectbox" data-target="#select_list" style={{ lineHeight: 'normal' }}>Select me</div>
          <div className="selectbox_list" id="select_list">
            <div>SelectBox Content1</div>
            <div>SelectBox Content2</div>
            <div>SelectBox Content3</div>
          </div>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="selectbox">
  <div class="btn btn_selectbox" data-rule="selectbox" data-target="#select_list">Select Box</div>
  <div class="selectbox_list" id="select_list">
    <a href="">SelectBox Content1</a>
    <a href="">SelectBox Content2</a>
    <a href="">SelectBox Content3</a>
  </div>
</div>`}
            </CodeHighlight>
          </TabPane>
          <TabPane tab="JAVASCRIPT" key="2">
            <CodeHighlight language="JS">
              {`var selectboxs = document.querySelectorAll('[data-rule="selectbox"]');
for (var i = 0; i < selectboxs.length; i++){ new Selectbox(selectboxs[i]) }`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>


    </>
  );
}

export default SelectBox_Component;
